import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import Box from '@rexlabs/box';
import { StyleSheet, useStyles, mq } from '@rexlabs/styling';
var defaultStyles = StyleSheet({
  container: _objectSpread({
    width: '100%'
  }, mq.styles.combine([{
    queries: {
      maxWidth: 's'
    },
    styles: {
      height: function height(_ref) {
        var token = _ref.token;
        return token('topBar.mobile.height', '5.2rem');
      },
      backgroundColor: function backgroundColor(_ref2) {
        var token = _ref2.token;
        return token('topBar.mobile.background.color', token('color.container.static.primary.default'));
      }
    }
  }, {
    queries: {
      minWidth: 's',
      maxWidth: 'm'
    },
    styles: {
      height: function height(_ref3) {
        var token = _ref3.token;
        return token('topBar.tablet.height', '6.4rem');
      },
      backgroundColor: function backgroundColor(_ref4) {
        var token = _ref4.token;
        return token('topBar.tablet.background.color', token('color.container.static.primary.default'));
      }
    }
  }, {
    queries: {
      minWidth: 'm'
    },
    styles: {
      height: function height(_ref5) {
        var token = _ref5.token;
        return token('topBar.desktop.height', '8.8rem');
      },
      backgroundColor: function backgroundColor(_ref6) {
        var token = _ref6.token;
        return token('topBar.desktop.background.color', token('color.pageBackground.default'));
      }
    }
  }]))
});
export function TopBar(_ref7) {
  var children = _ref7.children;
  var s = useStyles(defaultStyles, 'TopBar');
  return /*#__PURE__*/React.createElement(Box, _extends({}, s('container'), {
    flex: "0 0 auto",
    alignItems: "center"
  }), children);
}